export const initialAlert = {
    title: '',
    content: '',
    textBtn1: '',
    textBtn2: '',
    funcBtn: () => { },
    open: false,
    onClose: () => { }
}